var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { Button, Dimmer, Grid, Header, Input, Loader, Menu, Message, Modal, Select, Table } from "semantic-ui-react";
import { CatalogMode, getWithAuthn } from "../RequestHelpers";
import { RelevantCatalogType } from "../kit/automated-pro/RnaCatalog";
import { MetaCatalogLoader } from "../kit/Catalog";
import { getSecondaryIfProbeCatalog } from "../kit/secondary-if/SecondaryIfCatalog";
import { LoadWrapper } from "../kit/rna-fish/LoadWrapper";
import SimpleFormWithErrorDisplay from "./SimpleFormWithErrorDisplay";
import FieldWithErrorDisplay from "../FieldWithErrorDisplay";
import UploadFileModal from "./UploadFileModal";
import { displayLocalTimestamp } from "./AllOrdersPage";
import ReactTable from "react-table";
var SecondaryIfProbeTrackingPage = /** @class */ (function (_super) {
    __extends(SecondaryIfProbeTrackingPage, _super);
    function SecondaryIfProbeTrackingPage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SecondaryIfProbeTrackingPage.prototype.render = function () {
        var renderer = function (catalog) {
            return React.createElement(SecondaryIfProbeTrackingContent, { catalog: catalog });
        };
        return React.createElement(LoadWrapper, { loader: new MetaCatalogLoader(CatalogMode.Internal, RelevantCatalogType.Initial), render: renderer });
    };
    return SecondaryIfProbeTrackingPage;
}(React.PureComponent));
export default SecondaryIfProbeTrackingPage;
var SecondaryIfProbeTrackingContent = /** @class */ (function (_super) {
    __extends(SecondaryIfProbeTrackingContent, _super);
    function SecondaryIfProbeTrackingContent(props) {
        var _this = _super.call(this, props) || this;
        _this.renderTable = function (resp) {
            return React.createElement(Table, { striped: true, celled: true },
                React.createElement(Table.Header, null,
                    React.createElement(Table.Row, null,
                        React.createElement(Table.HeaderCell, null, "Probe"),
                        React.createElement(Table.HeaderCell, null, "10 \u00B5g aliquots"))),
                React.createElement(Table.Body, null, resp.probes.map(function (entry, index) {
                    return React.createElement(Table.Row, { key: index },
                        React.createElement(Table.Cell, null,
                            entry.probeName,
                            "-",
                            entry.hcrAmplifier.id,
                            " ",
                            _this.editProbeEntry(entry, _this.props.catalog)),
                        React.createElement(Table.Cell, null, entry.ug10Aliquots));
                })));
        };
        _this.renderEventsTable = function (resp) {
            return React.createElement(React.Fragment, null,
                React.createElement(Header, null, "Events"),
                React.createElement(ReactTable, { columns: [
                        {
                            id: 'name',
                            Header: 'User',
                            accessor: function (e) { return e.user.name; }
                        },
                        {
                            id: 'type',
                            Header: 'Type',
                            accessor: function (e) { return e.type; }
                        },
                        {
                            id: 'probe',
                            Header: 'Probe',
                            accessor: function (e) { return e.probeName; }
                        },
                        {
                            id: 'hcrAmplifier',
                            Header: 'Amplifier',
                            accessor: function (e) { return e.hcrAmplifier.id; }
                        },
                        {
                            id: 'msg',
                            Header: 'Message',
                            accessor: function (e) { return e.msg; },
                            Cell: function (props) { return React.createElement("span", { title: props.value }, props.value); }
                        },
                        {
                            id: 'createdAt',
                            Header: 'Created',
                            accessor: function (e) { return displayLocalTimestamp(e.createdAt); }
                        },
                    ], data: resp.probeEvents, defaultPageSize: 50, defaultSorted: [{
                            id: 'createdAt'
                        }], minRows: 1 }));
        };
        _this.loadData = function () {
            _this.setState({ loading: true }, function () {
                getWithAuthn('/admin/inventory/secondary-if-probes')
                    .then(function (resp) {
                    if (resp.ok) {
                        return resp.json();
                    }
                    else {
                        return undefined;
                    }
                })
                    .then(function (resp) {
                    if (resp === undefined) {
                        _this.setState({
                            loading: false,
                            error: true
                        });
                    }
                    else {
                        _this.setState({
                            error: false,
                            loading: false,
                            response: resp
                        });
                    }
                })
                    .catch(function (rej) {
                    console.error("Couldn't load report: " + rej);
                });
            });
        };
        _this.inputNewAliquots = function (catalog) {
            var renderProbeModal = function (props) {
                return React.createElement(ProbeInventoryModal, __assign({ catalog: catalog }, props));
            };
            return React.createElement(Modal, { closeIcon: true, onClose: _this.loadData, trigger: React.createElement(Button, { icon: 'plus', labelPosition: 'left', label: 'Input new aliquots' }) },
                React.createElement(Modal.Header, null, "Input new aliquots"),
                React.createElement(Modal.Content, null,
                    React.createElement(SimpleFormWithErrorDisplay, { render: renderProbeModal, successMessage: 'New aliquots inputted' })));
        };
        _this.editProbeEntry = function (probeEntry, catalog) {
            var renderProbeModal = function (props) {
                return React.createElement(ProbeInventoryModal, __assign({ probeEntry: probeEntry, catalog: catalog }, props));
            };
            return React.createElement(Modal, { closeIcon: true, onClose: _this.loadData, trigger: React.createElement(Button, { icon: 'edit', size: 'mini' }) },
                React.createElement(Modal.Header, null, "Edit probe inventory"),
                React.createElement(Modal.Content, null,
                    React.createElement(SimpleFormWithErrorDisplay, { render: renderProbeModal, successMessage: 'Inventory updated' })));
        };
        _this.uploadInventory = function () {
            return React.createElement(Modal, { closeIcon: true, onClose: _this.loadData, trigger: React.createElement(Button, { icon: 'plus', labelPosition: 'left', label: 'Upload inventory' }) },
                React.createElement(Modal.Header, null, "Upload inventory"),
                React.createElement(Modal.Content, null,
                    React.createElement(UploadFileModal, { path: "/admin/inventory/secondary-if-probes/upload-current-inventory" })));
        };
        _this.state = {
            loading: false,
            error: false
        };
        return _this;
    }
    SecondaryIfProbeTrackingContent.prototype.render = function () {
        return React.createElement(Dimmer.Dimmable, { className: 'non-header-portion' },
            React.createElement(Dimmer, { active: this.state.loading, inverted: true },
                React.createElement(Loader, null)),
            this.state.error &&
                React.createElement(Message, { negative: true }, "Report could not be loaded."),
            React.createElement(Menu, null,
                React.createElement(Menu.Item, null, this.uploadInventory()),
                React.createElement(Menu.Item, null, this.inputNewAliquots(this.props.catalog))),
            this.state.response && this.renderTable(this.state.response),
            this.state.response && this.renderEventsTable(this.state.response));
    };
    SecondaryIfProbeTrackingContent.prototype.componentDidMount = function () {
        this.loadData();
    };
    return SecondaryIfProbeTrackingContent;
}(React.PureComponent));
var ProbeInventoryModal = /** @class */ (function (_super) {
    __extends(ProbeInventoryModal, _super);
    function ProbeInventoryModal(props) {
        var _this = _super.call(this, props) || this;
        _this.probeCatalog = function () {
            return getSecondaryIfProbeCatalog(false, _this.props.catalog.secondaryIfCatalog);
        };
        _this.onProbeChange = function (_, data) {
            var probe = _this.probeCatalog().probes.find(function (p) { return p.id === data.value; });
            if (probe === undefined) {
                throw new RangeError("Could not find probe " + data.value);
            }
            // The new probe has its own amplifier linkage rows, so any previous selection is invalid.
            _this.setState({
                probe: probe,
                probeAmplifier: probe.amplifiers.length === 1 ? probe.amplifiers[0] : undefined
            });
        };
        _this.onAmplifierChange = function (_, data) {
            var _a;
            var probeAmplifier = (_a = _this.state.probe) === null || _a === void 0 ? void 0 : _a.amplifiers.find(function (a) { return a.id === data.value; });
            if (probeAmplifier === undefined) {
                throw new RangeError("Invalid amplifier " + data.value);
            }
            _this.setState({
                probeAmplifier: probeAmplifier
            });
        };
        _this.onLotNumberChange = function (_, data) {
            var str = data.value;
            _this.setState({ lotNumber: str });
        };
        _this.onUg10AliquotsChange = function (_, data) {
            var str = data.value;
            var num = parseInt(str, 10);
            if (isNaN(num)) {
                // no op -- discard input
                return;
            }
            _this.setState({ ug10Aliquots: num });
        };
        _this.submit = function () {
            var _a;
            if (_this.props.probeEntry == null) {
                _this.props.postRequest("/admin/inventory/secondary-if-probes/add-new-aliquots", {
                    probeAmplifierId: (_a = _this.state.probeAmplifier) === null || _a === void 0 ? void 0 : _a.id,
                    lotNumber: _this.state.lotNumber,
                    ug10Aliquots: _this.state.ug10Aliquots
                });
            }
            else {
                _this.props.postRequest("/admin/inventory/secondary-if-probes/update-existing-entry/id/" + encodeURIComponent(_this.props.probeEntry.id), {
                    ug10Aliquots: _this.props.probeEntry.ug10Aliquots === _this.state.ug10Aliquots ? null : _this.state.ug10Aliquots
                });
            }
        };
        // In edit mode the probe/amplifier selects are disabled; resolve the entry's pair from the
        // catalog so the dropdowns can display it.
        var entryProbe = props.probeEntry
            ? _this.probeCatalog().probesByAmplifierId.get(props.probeEntry.probeAmplifierId)
            : undefined;
        _this.state = {
            probe: entryProbe,
            probeAmplifier: entryProbe === null || entryProbe === void 0 ? void 0 : entryProbe.amplifiers.find(function (a) { var _a; return a.id === ((_a = _this.props.probeEntry) === null || _a === void 0 ? void 0 : _a.probeAmplifierId); }),
            lotNumber: "",
            ug10Aliquots: props.probeEntry ? props.probeEntry.ug10Aliquots : 0
        };
        return _this;
    }
    ProbeInventoryModal.prototype.render = function () {
        var _a, _b, _c, _d;
        var probeOptions = this.probeCatalog().probes.map(function (p) { return ({
            text: p.name,
            value: p.id
        }); });
        var amplifierOptions = ((_b = (_a = this.state.probe) === null || _a === void 0 ? void 0 : _a.amplifiers) !== null && _b !== void 0 ? _b : []).map(function (a) { return ({
            text: a.amplifier.id,
            value: a.id
        }); });
        return React.createElement(Grid, { columns: 2 },
            React.createElement(Grid.Row, null,
                React.createElement(Grid.Column, null,
                    React.createElement(FieldWithErrorDisplay, { errorPath: '/probe', errors: this.props.state.errors, labelContent: 'Probe' },
                        React.createElement(Select, { name: 'probe', className: "label-dropdown", disabled: this.props.probeEntry != null, onChange: this.onProbeChange, placeholder: 'Select...', options: probeOptions, value: (_c = this.state.probe) === null || _c === void 0 ? void 0 : _c.id, search: true }))),
                React.createElement(Grid.Column, null,
                    React.createElement(FieldWithErrorDisplay, { errorPath: '/probeAmplifier', errors: this.props.state.errors, labelContent: 'Amplifier' },
                        React.createElement(Select, { className: "label-dropdown", disabled: this.props.probeEntry != null, value: (_d = this.state.probeAmplifier) === null || _d === void 0 ? void 0 : _d.id, onChange: this.onAmplifierChange, placeholder: 'Select...', options: amplifierOptions, name: 'probe-amplifier' })))),
            this.props.probeEntry == null &&
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, null,
                        React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/lotNumber', labelContent: 'Lot Number' },
                            React.createElement(Input, { onChange: this.onLotNumberChange, placeholder: 'Lot Number', type: "text", value: this.state.lotNumber })))),
            React.createElement(Grid.Row, null,
                React.createElement(Grid.Column, null,
                    React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/ug10Aliquots', labelContent: '10 µg aliquots' },
                        React.createElement(Input, { onChange: this.onUg10AliquotsChange, placeholder: '0', type: "number", value: this.state.ug10Aliquots })))),
            React.createElement(Grid.Row, null,
                React.createElement(Grid.Column, null,
                    React.createElement(Button, { disabled: this.props.state.loading || this.props.state.success || this.state.probeAmplifier === undefined, icon: 'plus', label: this.props.probeEntry ? 'Save update' : 'Add new probe aliquots', labelPosition: 'left', onClick: this.submit, positive: true }))));
    };
    return ProbeInventoryModal;
}(React.PureComponent));
//# sourceMappingURL=SecondaryIfProbeTrackingPage.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/admin/SecondaryIfProbeTrackingPage.js
// module id = 1475
// module chunks = 0